<template>
  <Dialog :commonDialog="mDialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex>Manage {{ title }}</v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            color="cyan"
            class="mx-1 custom-bold-button white--text"
            @click="createSetting"
          >
            Add {{ title }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>

    <template v-slot:body>
      <v-form ref="settingsForm" v-model.trim="formValid" lazy-validation>
        <v-container class="py-0">
          <table width="100%">
            <tr v-for="(type, index) in settingsList" :key="index">
              <td width="90%">
                <v-text-field
                  v-model.trim="type.value"
                  dense
                  filled
                  flat
                  solo
                  hide-details
                  full-width
                  :rules="[validateRules.required(type.value, title)]"
                  :placeholder="title"
                />
              </td>

              <td width="10%" v-if="settingsList.length > 1">
                <v-icon color="deep-orange" @click="deleteSetting(index)"
                  >mdi-delete</v-icon
                >
              </td>
            </tr>
          </table>
        </v-container>
      </v-form>
    </template>

    <template v-slot:action>
      <v-btn
        depressed
        color="cyan"
        class="mx-2 custom-bold-button white--text"
        @click="updateSettings"
        >Save</v-btn
      >

      <v-btn depressed class="mx-2" @click="$emit('close-dialog', true)"
        >Close</v-btn
      >
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { PATCH } from "@/core/services/store/request.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    mDialog: Boolean,
    settings: Array,
    title: String,
    endpoint: String,
    value: String,
  },
  data() {
    return {
      formValid: true,
      pageLoading: false,
      settingsList: [],
    };
  },
  watch: {
    mDialog(val) {
      if (console) console.log("Manage-Motor-Settings mDialog changed:", val);
    },
    settings: {
      deep: true,
      immediate: true,
      handler(param) {
        this.settingsList =
          param && param.length
            ? param.map((i) => ({
                id: i.value,
                field: this.value,
                value: i.text,
                activated: i.activated,
              }))
            : [{ id: null, field: this.value, value: null, activated: true }];
      },
    },
  },
  methods: {
    updateSettings() {
      if (!this.$refs.settingsForm.validate()) return;

      this.pageLoading = true;

      this.$store
        .dispatch(PATCH, {
          url: this.endpoint,
          data: {
            field: this.value,
            settings: this.settingsList.map((i) => ({
              id: i.id,
              text: i.value,
              activated: i.activated,
            })),
          },
        })
        .then(() => {
          this.$emit("close-dialog", true);
          this.$emit("get-settings");
        })
        .finally(() => (this.pageLoading = false));
    },

    createSetting() {
      this.settingsList.push({
        id: null,
        value: null,
        field: this.value,
        activated: true,
      });
    },

    deleteSetting(index) {
      if (this.settingsList.length > 1) {
        this.settingsList.splice(index, 1);
      }
    },
  },
  mounted() {
    if (console) console.log("Manage-Motor-Settings mounted");
  },
  components: { Dialog },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
